module.exports = __webpack_public_path__ + "static/media/18.257b5ea7.svg";